export default {
  name: 'VipAgreement',
  components: {}
};